module.exports = __webpack_public_path__ + "static/img/smart0.14e439b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/smart/smart0.jpg
// module id = 87ix
// module chunks = 1